
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from '@kontent-ai/delivery-sdk';
import type { CoreContentType } from "../system/index.js";
import type { PageHome, PageGeneral, PageHardcoded } from "./index.js";

/**
 * 🔗 Nav // Internal Link
 *
 * Id: 341fcbbb-2fd8-45e6-8313-66da700ed71d
 * Codename: internal_link
 */
export type NavInternalLink = CoreContentType<
    NavInternalLinkElementCodenames,
    {
        /**
         * Label
         *
         * Type: text
         * Required: true
         * Codename: label
         * Id: 4c9f1bfc-ff9d-4f2b-8e85-73752256bcdd
         */
        readonly label: Elements.TextElement;
        /**
         * Page
         *
         * Type: modular_content
         * Required: true
         * Codename: page
         * Id: f91d6194-c279-4ab5-87ec-d7db9253ccc0
         */
        readonly page: Elements.LinkedItemsElement<PageHome | PageGeneral | PageHardcoded>;
    },
    'internal_link'
>;

/**
 * Type representing all available element codenames for 🔗 Nav // Internal Link
 */
export type NavInternalLinkElementCodenames = 'label' | 'page';

/**
 * Type guard for 🔗 Nav // Internal Link
 *
 * Id: 341fcbbb-2fd8-45e6-8313-66da700ed71d
 * Codename: internal_link
 */
export function isNavInternalLink(item: CoreContentType | undefined | null): item is NavInternalLink {
    return item?.system?.type === 'internal_link';
}
